import React from 'react'
import { Link } from 'react-router-dom'
import ProfilePanel from './ProfilePanel'

export default function ProfileNeedsAttention({ items, onNavigate }) {
  const handleAction = (item) => {
    if (item.href) return
    if (item.section) onNavigate?.(item.section, item)
  }

  return (
    <ProfilePanel
      title="Needs attention"
      hint={items.length ? `${items.length} open item${items.length === 1 ? '' : 's'}` : 'All clear'}
    >
      {items.length === 0 ? (
        <p className="text-sm text-slate-500 m-0">No outstanding compliance actions.</p>
      ) : (
        <ul className="m-0 p-0 list-none">
          {items.map((item) => (
            <li
              key={item.id}
              className="flex items-center justify-between gap-3 py-2.5 border-b border-slate-100 last:border-0"
            >
              <span className="text-sm text-slate-800">{item.label}</span>
              {item.href ? (
                <Link
                  to={item.href}
                  className="text-teal-700 text-sm font-semibold whitespace-nowrap hover:underline"
                >
                  {item.actionLabel} →
                </Link>
              ) : (
                <button
                  type="button"
                  onClick={() => handleAction(item)}
                  className="text-teal-700 text-sm font-semibold whitespace-nowrap hover:underline bg-transparent border-0 cursor-pointer p-0"
                >
                  {item.actionLabel} →
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </ProfilePanel>
  )
}
